function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "225",
  height: "160",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 4a3 3 0 013-3h216a3 3 0 013 3v151.722a3 3 0 01-3 3H4.5a3 3 0 01-3-3V4z",
  stroke: "#DDE0E4",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("rect", {
  x: "30.5",
  y: "18",
  width: "163.999",
  height: "26.837",
  rx: "2",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "30.5",
  y: "88.333",
  width: "163.999",
  height: "53.675",
  rx: "2",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "30.5",
  y: "52.723",
  width: "98.595",
  height: "27.778",
  rx: "2",
  fill: "#6310E5"
}), /*#__PURE__*/React.createElement("rect", {
  x: "138.012",
  y: "53.166",
  width: "56.489",
  height: "27.763",
  rx: "2",
  fill: "#6310E5"
})));